import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

const FLOODLIGHTING_FIELD = 'floodlightingType';

class CourtsInformation extends VenueRegistrationFormModal {
	constructor() {
		super({
			wrapperSelector: '.p-venue-info-landing-page-singlesite',
			sectionWrapperSelector: '.p-venue-info-landing-page-singlesite-wrapper',
			modalSelector: '#js-venue-info-courts-form-modal',
			triggerSelectors: ['.js-venue-info-add-courts', '.js-venue-info-edit-courts'],
			stepsEndpointAttr: 'courts-steps-endpoint',
			submitEndpointAttr: 'courts-submit-endpoint',
			logPrefix: 'CourtsInformation'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: true,
			isBackButtonEnabled: true,
			radioAnswerField: 'id',
			isRenderDependentQuestion: true,
			conditionalStepsVisiblity: true,
			isExitButtonEnabled: true,
			exitButtonLabel: 'Exit',
			nextStepButtonLabel: 'Save and continue',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue'
			}
		};
	}

	cacheFloodlightingTriggerIds() {
		this._floodlightingTriggerIds = new Set(
			(this.formGenerator?.questions || []).flatMap((question) => {
				const sections = question.sections?.length
					? question.sections
					: [{ options: question.options || [] }];

				return sections.flatMap((section) =>
					(section.options || [])
						.filter((option) => option.triggersFloodlighting)
						.map((option) => option.id)
				);
			})
		);
	}

	hasFloodlitCourts() {
		const triggerIds = this._floodlightingTriggerIds;
		if (!triggerIds?.size) {
			return false;
		}

		return Object.values(this.formGenerator?.answers || {})
			.flatMap((step) => Object.values(step || {}))
			.flatMap((answer) => (Array.isArray(answer?.value) ? answer.value : []))
			.some((option) => triggerIds.has(option?.id) && Number(option.value) > 0);
	}

	syncFloodlightingVisibility() {
		const form = this.formGenerator;
		const question = form?.questions?.find((q) => q.fieldName === FLOODLIGHTING_FIELD);
		if (!form || !question || this._syncingFloodlighting) {
			return;
		}

		const shouldShow = this.hasFloodlitCourts();
		if (shouldShow === !!question.visible) {
			return;
		}

		this._syncingFloodlighting = true;
		try {
			form.beforeDepChangeHandler(shouldShow ? [question.id] : [], shouldShow ? [] : [question.id]);
		} finally {
			this._syncingFloodlighting = false;
		}
	}

	afterFormGeneratorInit() {
		const form = this.formGenerator;
		if (!form) {
			return;
		}

		this.cacheFloodlightingTriggerIds();

		const wrap = (methodName) => {
			const original = form[methodName].bind(form);
			form[methodName] = (...args) => {
				original(...args);
				this.syncFloodlightingVisibility();
			};
		};

		wrap('updateAnswers');
		wrap('clearQuestionAnswer');
		this.syncFloodlightingVisibility();
	}
}

VenueRegistrationFormModal.boot(CourtsInformation);

export default CourtsInformation;
